import { correlationIdSchema as e, pageLimitSchema as t, uuidSchema as n } from "../common/index.js";
import { z as r } from "zod";
// src/incidents/incidents.schema.ts
var i = 262144;
function a(e, t = !1) {
	return r.string().refine((n) => [...n].length <= e && (!t || n.trim().length > 0) && n.isWellFormed() && !n.includes("\0"), `Text must contain at most ${e} Unicode code points${t ? " and not be blank" : ""}.`);
}
var o = r.enum(["monitoring", "phone"]), s = r.enum([
	"open",
	"acknowledged",
	"resolved"
]), c = r.number().int().min(1).max(4), l = r.number().int().positive(), u = r.iso.datetime({ offset: !1 }), d = r.enum(["active", "all"]), f = r.array(r.strictObject({
	key: a(100, !0),
	value: a(2e3)
})).max(50).refine((e) => new Set(e.map((e) => e.key)).size === e.length, { message: "Extra information keys must be unique." }), p = {
	sourceScope: a(128, !0),
	requestId: a(200, !0),
	title: a(250, !0),
	description: a(1e4).optional(),
	sourceReference: a(1e3).optional(),
	sourceEventAt: u.optional(),
	customerId: n.optional(),
	teamId: n.optional(),
	extraInformation: f.optional()
}, m = r.strictObject(p), h = r.discriminatedUnion("sourceKind", [r.strictObject({
	...p,
	sourceKind: r.literal("monitoring"),
	priority: c
}), r.strictObject({
	...p,
	sourceKind: r.literal("phone"),
	priority: r.unknown().optional().transform(() => 1)
})]), g = r.unknown().superRefine((e, t) => {
	try {
		let t = JSON.stringify(e);
		if (t !== void 0 && new TextEncoder().encode(t).length <= 262144) return;
	} catch {}
	t.addIssue({
		code: "custom",
		message: "Alert must serialize within 256 KiB."
	});
}).pipe(h), _ = r.strictObject({
	kind: r.literal("user"),
	userId: n
}), v = r.strictObject({
	kind: r.literal("link"),
	deliveryChannel: r.string().regex(/^[-a-z0-9]{1,80}$/)
}), y = r.strictObject({
	kind: r.literal("voice"),
	deliveryChannel: r.literal("voice")
}), b = r.discriminatedUnion("kind", [
	_,
	v,
	y
]), x = _.extend({ displayName: r.union([a(200, !0).describe("Known historical actor display name."), r.null()]) }), S = r.discriminatedUnion("kind", [
	x,
	v,
	y
]), C = r.strictObject({
	id: n,
	name: a(100, !0)
}), w = r.strictObject({
	id: n,
	title: p.title,
	receivedAt: u,
	sourceKind: o,
	status: s,
	priority: c,
	version: l,
	customer: C.nullable(),
	team: C.nullable()
}), T = w.extend({
	description: r.union([a(1e4).describe("Optional incident description, preserved as inert text."), r.null()]),
	sourceReference: r.union([a(1e3).describe("Optional source reference, preserved without dereferencing."), r.null()]),
	sourceEventAt: u.nullable(),
	extraInformation: f,
	acknowledgement: r.strictObject({
		at: u,
		actor: S
	}).nullable(),
	resolution: r.strictObject({
		at: u,
		actor: x
	}).nullable()
}).refine((e) => e.status === "open" ? e.acknowledgement === null && e.resolution === null : e.status === "acknowledged" ? e.acknowledgement !== null && e.resolution === null : e.resolution !== null && (e.acknowledgement === null || Date.parse(e.resolution.at) >= Date.parse(e.acknowledgement.at)), "Incident lifecycle attribution must match its status and transition order."), E = r.string().min(1).max(1024).regex(/^[A-Za-z0-9_-]+$/), D = r.strictObject({
	version: r.literal(1),
	receivedAt: u,
	id: n,
	viewerId: n,
	view: d,
	scopeBinding: r.string().min(1).max(128).regex(/^[A-Za-z0-9_-]+$/)
}), O = r.strictObject({
	view: d.default("active"),
	cursor: E.optional(),
	limit: t
}), k = r.strictObject({
	items: r.array(w).max(100),
	nextCursor: E.nullable()
}), A = r.strictObject({ incidentId: n }), j = r.strictObject({}), M = r.strictObject({
	priority: c,
	expectedVersion: l
}), N = r.strictObject({
	teamId: n,
	expectedVersion: l
}), P = r.string().min(16).max(128).regex(/^[A-Za-z0-9_-]+$/), F = r.enum([
	"INVALID_REQUEST",
	"SESSION_REQUIRED",
	"CAPABILITY_DENIED",
	"NOT_FOUND",
	"VERSION_CONFLICT",
	"INCIDENT_RESOLVED",
	"CUSTOMER_ARCHIVED",
	"INCIDENT_TEAM_FIXED",
	"TEAM_INACTIVE",
	"IDEMPOTENCY_CONFLICT",
	"PAYLOAD_TOO_LARGE",
	"RATE_LIMITED",
	"STORAGE_UNAVAILABLE",
	"DEPENDENCY_UNAVAILABLE",
	"INTERNAL_ERROR"
]), I = r.strictObject({
	code: F,
	message: r.enum([
		"Incident request is invalid.",
		"Sign in to continue.",
		"Incident access is not permitted.",
		"Incident was not found.",
		"Incident has changed; reload before retrying.",
		"Resolution is final.",
		"Archived customers cannot be selected.",
		"Team can only be changed while the incident is open.",
		"Select one active team.",
		"Idempotency key was already used for another request.",
		"Alert exceeds the supported size.",
		"Too many requests; retry later.",
		"Incident storage is unavailable.",
		"Incident dependency is unavailable.",
		"Incident response is unavailable."
	]),
	correlationId: e,
	fieldErrors: r.partialRecord(r.enum([
		"priority",
		"expectedVersion",
		"version",
		"q",
		"teamId",
		"view",
		"cursor",
		"limit",
		"title",
		"sourceKind",
		"sourceScope",
		"requestId",
		"description",
		"sourceReference",
		"sourceEventAt",
		"customerId",
		"extraInformation"
	]), r.enum([
		"Invalid value.",
		"Required value.",
		"Limit exceeded.",
		"Select one active team."
	])).optional()
}), L = I.extend({
	code: r.enum([
		"VERSION_CONFLICT",
		"INCIDENT_RESOLVED",
		"INCIDENT_TEAM_FIXED"
	]),
	current: T.optional()
});
export { i as INCIDENT_INPUT_MAX_BYTES, S as incidentActorProjectionSchema, b as incidentActorSchema, L as incidentConflictSchema, m as incidentContentSchema, D as incidentCursorPayloadSchema, E as incidentCursorSchema, T as incidentDetailSchema, F as incidentErrorCodeSchema, I as incidentErrorSchema, f as incidentExtraInformationSchema, P as incidentIdempotencyKeySchema, u as incidentInstantSchema, v as incidentLinkActorSchema, O as incidentListQuerySchema, d as incidentListViewSchema, k as incidentPageSchema, A as incidentPathSchema, M as incidentPriorityCommandSchema, c as incidentPrioritySchema, o as incidentSourceKindSchema, j as incidentStatusCommandSchema, s as incidentStatusSchema, w as incidentSummarySchema, N as incidentTeamCommandSchema, x as incidentUserActorProjectionSchema, _ as incidentUserActorSchema, l as incidentVersionSchema, y as incidentVoiceActorSchema, g as incomingAlertSchema };

//# sourceMappingURL=incidents.schema.js.map